import { TimeFormat } from "services/subscription/types";

export const shrinkText = (title: any, length: number) => {
  return title.length > length ? `${title.slice(0, length)}...` : title;
};

// add the alpha for given color
export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const displayTimeFormat = (timeFormat: TimeFormat) => {
  if (!timeFormat) return null;
  if (timeFormat === TimeFormat.D) {
    return "day";
  } else if (timeFormat === TimeFormat.M) {
    return "month";
  } else if (timeFormat === TimeFormat.W) {
    return "week";
  } else {
    return "year";
  }
};
